import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import { withoutPublicWorkerPool } from "utils/distribution";
import {
  PUBLIC_WORKER_POOL_NAME,
  PUBLIC_WORKER_POOL_URL,
} from "views/Account/WorkerPool/constants";

const noPublicWorkerPool = withoutPublicWorkerPool();

const IntentProjectsTableWorkerPoolCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const workerPool = intentProject.workerPool;

  return (
    <TableSimpleCell {...cellProps}>
      {workerPool && (
        <TableCellLink href={`/worker-pool/${workerPool.id}`}>{workerPool.name}</TableCellLink>
      )}
      {!workerPool && !noPublicWorkerPool && (
        <TableCellLink href={PUBLIC_WORKER_POOL_URL}>{PUBLIC_WORKER_POOL_NAME}</TableCellLink>
      )}
      {!workerPool && noPublicWorkerPool && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default IntentProjectsTableWorkerPoolCell;
